import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { AuthConfigService } from '@flowx/designer/modules/auth/auth.service'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  #authConfigService = inject(AuthConfigService)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.#authConfigService.logout()
        }

        return throwError(error)
      })
    )
  }
}
